const french = {
}

export default french